import React from 'react';
import { Clock } from 'lucide-react';

interface ComingSoonBadgeProps {
  text?: string;
  className?: string;
}

export const ComingSoonBadge: React.FC<ComingSoonBadgeProps> = ({ 
  text = 'Coming Soon',
  className = ''
}) => {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 ${className}`}>
      <Clock className="w-3 h-3 mr-1" />
      {text}
    </span>
  );
};

